import { FC } from 'react'
import { useIntl } from 'react-intl'
import { virtualBoreholeFigureStyle } from './VirtualBoreholeFigure.style'

/**
 * VirtualBoreholeFigureProps contains properties for the component.
 */
export interface VirtualBoreholeFigureProps {
  image: string
}

/**
 * VirtualBoreholeFigure displays figures and legend for virtual boreholes.
 * @param props Properties for component.
 * @returns JSX component.
 */
export const VirtualBoreholeFigure: FC<VirtualBoreholeFigureProps> = (props: VirtualBoreholeFigureProps) => {
  const classes = virtualBoreholeFigureStyle()
  const intl = useIntl()

  return <img className={classes.root} src={props.image} alt={intl.formatMessage({ id: 'tools.virtualborehole' })} />
}
